import { alertTypes } from '@/returns/constants'

export const alertTypeLabels = {
  [alertTypes.missingCustomsData]: 'Falta información de aduanas',
  [alertTypes.refundOnHold]: 'Reembolso en espera',
  [alertTypes.exchangeOnHold]: 'Pedido de cambio en espera',
  [alertTypes.exchangeOrderError]: 'Error al crear pedido de cambio',
  [alertTypes.negativeSentiment]: 'Sentimiento negativo',
  [alertTypes.timeIssue]: 'Problema urgente',
  [alertTypes.unexpectedItems]: 'Productos devueltos adicionales',
}
